import { render, staticRenderFns } from "./OrderListPlacedPage.vue?vue&type=template&id=de7c1aaa&"
import script from "./OrderListPlacedPage.vue?vue&type=script&lang=js&"
export * from "./OrderListPlacedPage.vue?vue&type=script&lang=js&"
import style0 from "./OrderListPlacedPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports